// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/update-comment-tt-request-schema',
  type: 'object',
  required: [],
  properties: {
    ids: {
      type: 'array',
      items: {
        type: 'integer',
      },
    },
    commentTT: {
      type: 'string',
    },
  },
} as IJSONSchema;

export default schema;
